$(document).ready( function() {
  ko.applyBindings(window.viewModel);
});